var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("applicant-list-template", {
    attrs: {
      loading: _vm.loading,
      errorMessageLogs: _vm.errorMessageLogs,
      resData: _vm.resData,
      total: _vm.total,
      page: _vm.page,
      loadMore: _vm.loadMore,
      loadingSearch: _vm.loadingSearch,
      perPage: _vm.perPage,
      dataOffice: _vm.dataOffice,
      dataArea: _vm.dataArea,
    },
    on: {
      search: function ($event) {
        return _vm.search($event)
      },
      "change-per-page": function ($event) {
        return _vm.changePerPage($event)
      },
      "change-column": function ($event) {
        return _vm.changeColumn($event)
      },
      export: function ($event) {
        return _vm.exportCSV($event)
      },
      "change-page": function ($event) {
        return _vm.changePage($event)
      },
      "change-office": function ($event) {
        return _vm.changeOffice($event)
      },
      "get-current-items": function ($event) {
        return _vm.getCurrentItems($event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }